<div class="flex h-full flex-1">
  <div class="h-full overflow-hidden border-r border-r-neutral-300">
    @if (chatState.features().showThreadTabs) {
      <chat-tabs
        [selectedThread]="chatState.selectedThread()"
        [unreads]="chatState.unreads()"
        [ownUserId]="chatState.ownUserId()"
        [myChatsCount]="myChatsCount()"
        [inQueueCount]="inQueueCount()"
        [isSearching]="chatState.isSearching()"
        [isLoading]="initialThreadsLoading() || chatState.threadsLoading()"
        (openThread)="onOpenThread($event)"
        (searchThreads)="onSearchThreads($event)"
        (searchOutput)="chatState.onThreadSearch($event)"
      >
      </chat-tabs>
    } @else {
      <!-- Simple threads list without tabs -->
      <div class="mr-3 flex h-full w-[350px] flex-col overflow-hidden">
        <h2 class="mb-4">{{ "chat.label.threads" | translate }}</h2>

        <!-- Search field -->
        <mat-form-field class="w-full">
          <mat-icon matIconPrefix>search</mat-icon>
          <mat-label>{{ "chat.label.searchPlaceholder" | translate }}</mat-label>
          <input
            matInput
            (input)="onSearchInput($event)"
          />
        </mat-form-field>

        <div class="flex h-full flex-col">
          @if (chatState.threadsLoading()) {
            <div class="flex h-full w-full items-center justify-center">
              <shared-loader></shared-loader>
            </div>
          } @else {
            <chat-threads-list
              [selectedThread]="chatState.selectedThread()"
              [threads]="chatState.displayThreads()"
              [unreads]="chatState.unreads()"
              [systemUsers]="chatState.systemUsers()"
              [ownUserId]="chatState.ownUserId()"
              (openThread)="onOpenThread($event)"
            />
          }
        </div>
      </div>
    }
  </div>

  @if (!!hasSelectedThread()) {
    <div class="min-w-0 flex-1">
      <chat-messages-list
        [loading]="chatState.messagesLoading() || chatState.threadDataLoading()"
        [ownUserId]="chatState.ownUserId()"
        [threadUserId]="chatState.selectedThread().ownerId"
        [threadId]="chatState.selectedThread().id"
        [clientProfile]="chatState.profile()"
        [ownerName]="chatState.selectedThread().ownerName"
        [messages]="chatState.messages()"
        [unreadCount]="chatState.unreads().get(chatState.selectedThread().id) || 0"
        [isAssignedToMe]="isThreadAssignedToMe()"
        (sendMessage)="chatState.onSendMessage($event)"
        (messagesBefore)="chatState.onMessagesBefore($event)"
        (messagesAfter)="chatState.onMessagesAfter($event)"
        (markRead)="chatState.onMessagesRead()"
        (retryMessage)="chatState.retryFailedMessage($event)"
        (takeIntoWork)="onTakeIntoWork()"
        (completeWork)="onCompleteWork()"
      >
      </chat-messages-list>
    </div>
  }

  @if (!!chatState.profile() && chatState.features().showMemberProfile) {
    <div class="min-w-0 flex-1">
      <chat-info-board
        [member]="chatState.profile()"
        [loading]="chatState.threadDataLoading()"
      ></chat-info-board>
    </div>
  } @else if (chatState.threadDataLoading() && chatState.features().showMemberProfile) {
    <div class="min-w-0 flex-1">
      <div class="ml-3 flex h-full w-full items-center justify-center rounded-lg bg-neutral-100 p-5 shadow-md">
        <shared-loader></shared-loader>
      </div>
    </div>
  }
</div>
